import { OrganizationId, WorkspaceWithRole } from "@/utils/types";

export const COOKIE_NAME_SELECTED_WORKSPACE_ID = "listen-selected-org-id";

export const getSavedWorkspaceId = (
  getCookie: () => OrganizationId | undefined
): OrganizationId | undefined => {
  return getCookie();
};

export const getSelectedWorkspaceId = ({
  savedOrgId,
  deeplinkOrgId,
  orgs,
}: {
  savedOrgId: OrganizationId | undefined;
  deeplinkOrgId: OrganizationId | undefined;
  orgs: WorkspaceWithRole[];
}) => {
  // prefer non-personal orgs over personal orgs
  const realWorkspaces = orgs.filter(
    // if org_id is provided, allow for supervisor roles to match
    (workspace) => workspace.role !== "supervisor"
  );
  const bestWorkspace =
    orgs.find((workspace) => workspace.id === deeplinkOrgId) ??
    orgs.find((workspace) => workspace.id === savedOrgId) ??
    realWorkspaces.find(
      (workspace) => !workspace.name.toLowerCase().includes(" personal")
    ) ??
    realWorkspaces[0] ??
    orgs[0];
  return bestWorkspace?.id;
};
